module.exports = __webpack_public_path__ + "static/media/adaptacion del arco - adaptado 50.da992cb2.png";